/**
 * @Author: v_jppjpeng
 * @Date: 2023-10-30 15:13:06
 * @Explain: 下拉菜单
 */
import classNames from 'classnames';
import { ReactNode } from 'react';
import { LinkProps } from 'tdesign-react';
import { Link } from '..';
import CustomSelect from '../customSelect';
import { SelectProps } from '../data.d';

/** 点击按钮 props */
export type LinkType = {
  className?: string;
  title?: ReactNode | string;
  theme?: LinkProps['theme'];
  iconFlag?: boolean;
  /** 前置 */
  prefixIcon?: LinkProps['prefixIcon'];
  prefixIconName?: string;
  /** 后置 */
  suffixIcon?: LinkProps['suffixIcon'];
  suffixIconName?: string;
};

type PropsType = {
  className?: string;
  children?: ReactNode;
  /** 按钮标题 */
  btnTitle?: string;
  /** 按钮参数 */
  btnProps?: LinkType;
} & SelectProps;

function MenuDropdown(props: PropsType) {
  const { children, overlayClassName, isGroup, btnTitle, btnProps } = props;

  return (
    <CustomSelect
      overlayClassName={classNames(
        {
          'default-td-dropdown': !isGroup,
          'default-td-dropdown-group': isGroup,
        },
        overlayClassName,
      )}
      matchButtonWidth={false}
      {...props}
    >
      {children || (
        <Link
          suffixIconName="triangle-down-arrow"
          {...btnProps}
          className={classNames('menu-dropdown-link', btnProps?.className)}
        >
          {btnTitle || btnProps?.title}
        </Link>
      )}
    </CustomSelect>
  );
}

export default MenuDropdown;
